export enum NewsletterLinkMode {
  MoviePage = 0,
  Ticket = 1,
}
